import type { PostCampaignsDetailedReportingEndpoint } from '@Common/types/bo/b2b/campaigns';

import { ResourceBasePath } from '@sh4res/bo-common/hooks';
import { downloadBuffer } from '@sh4res/bo-common/utils/downloadBuffer';

import type { DataProvider } from 'react-admin';

function base64ToBlob(base64: string): Blob {
  const binary = window.atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.codePointAt(index) ?? 0;
  }

  return new Blob([bytes], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
}

export async function exportCampaignDetailedReporting({
  resourceBasePath,
  dataProvider,
  campaignId,
}: {
  resourceBasePath: ResourceBasePath;
  dataProvider: DataProvider;
  campaignId: number;
}): Promise<void> {
  const response = await dataProvider.create<
    PostCampaignsDetailedReportingEndpoint['Client']['RequestBody'],
    PostCampaignsDetailedReportingEndpoint['Client']['ResponseBody']
  >(`${resourceBasePath}campaigns/detailed_reporting`, {
    data: { campaign_id: campaignId },
  });

  const blob = base64ToBlob(response.data.file_content_base64);
  downloadBuffer(blob, response.data.file_name);
}
